import React from 'react';
import { PinUnpinVideoDecorated } from 'components/video-box/common/pin-unpin-video';
import { DownloadVideo } from 'components/video-box';
import { VideoContextMenuDecorated } from 'components/video-context-menu';
import { VideoShareDropdownDecorated } from 'components/context-menu/video-share-dropdown';

export const VideoControlsMenu = ({ video }) => (
  <React.Fragment>
    <DownloadVideo video={video} />
    <PinUnpinVideoDecorated video={video} />
    <VideoShareDropdownDecorated />
    <VideoContextMenuDecorated video={video} testPrefix="search-page-video-" />
  </React.Fragment>
);
